import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';

/**
 * As the user may land on the Ad when already started, we need to save when it was.
 * @type {number}
 */
let startedPlayingAdAt;

export const getCmFields = ({
  adBreakDuration,
  ad = undefined,
  resetDurationServed = false,
  adIndex = -1,
}) => {
  if (resetDurationServed) {
    startedPlayingAdAt = Date.now();
  }
  const cmDurationServed = differenceInMilliseconds(Date.now(), startedPlayingAdAt);

  return {
    cmAdvertisingID: 'na',
    cmBidFloor: 0,
    cmClient: 'na',
    cmClientName: 'na', // TODO: the same as cmClient.
    cmClientVersion: 'na',
    cmCPM: 0,
    cmCPMCurrencyCode: 'na',
    cmCreativeFormat: 'na',
    cmDealID: 'na',
    cmDurationOriginal: ad ? ad.duration : '0',
    cmDurationServed,
    cmID: 'na',
    cmImpressionIndex: adIndex,
    cmLoadTime: 0,
    cmNetworkID: 'na',
    cmNetworkName: 'na',
    cmPlutoID: (ad && ad.ID) || 'na',
    cmPodCounter: 0,
    cmPodDuration: adBreakDuration,
    cmPodID: 'na',
    cmPodIndex: -1,
    cmRequestCounter: 0,
    cmServerID: 'na', // TODO: the same as cmSourceID.
    cmServerName: 'na', // TODO: the same as cmSourceName.
    cmSourceID: 'na',
    cmSourceName: 'na',
    cmTagURL: 'na',
    cmType: ad ? ad.type : 'na',
    cmURLDomain: 'na',
  };
};
